import { render, staticRenderFns } from "./DreadDiseaseBenefit.vue?vue&type=template&id=47a26345"
import script from "./DreadDiseaseBenefit.vue?vue&type=script&lang=js"
export * from "./DreadDiseaseBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports